
import { put, takeEvery } from 'redux-saga/effects'
import { push } from 'react-router-redux'

import {checkSessionStatus, login, logout} from '../api'
import * as actions from '../actionTypes'
import {deleteCookie} from '../utils'
import {checkFactorEditing} from './helpers'

export function* loginSaga(action) {
  try {
    const {username, password} = action.payload
    const user = yield login(username, password)

    yield put({type: actions.LOGIN_SUCCESS, payload: {user}})

    // store username, roles in sessionStorage
    sessionStorage.setItem('user', JSON.stringify({
      name: `${user.givenName} ${user.surname}`,
      roles: user.roles
    }))

    if(user.roles.indexOf('counselor') > -1) {
      yield put({type: actions.POPULATE_COUNSELOR_NAME, payload: {user}})
    }

    yield put({type: actions.THEME_REQUESTED, payload: {organizationId: user.organizationId}})
    yield put({type: actions.SET_RERUN_DECISIONS, payload: true })
    yield put(push('/'))

  } catch(error) {
    yield put({type: actions.LOGIN_FAILURE, payload: {error}})
  }
}

export function* logoutSaga() {
  try {
    const isEditingFactor = yield checkFactorEditing(actions.LOGOUT_REQUESTED)

    if(isEditingFactor)
      return

    yield put({type: actions.LOGOUT})

    sessionStorage.clear()
    deleteCookie('DcpSessionId') // @todo DcpSessionId should be in sessionStorage

    yield logout()
    yield put({type: actions.SESSION_EXIT}) // clear local session data
    yield put(push('/login'))
    
  } catch(e) {}
}

export function* checkSessionStatusSaga() {
  try {
    yield checkSessionStatus()
    yield put({
      type: actions.SESSION_IS_ACTIVE,
      // if server session is active we have username, roles in client session storage
      payload: {user: JSON.parse(sessionStorage.getItem('user'))}
    })
  } catch(e) {
    sessionStorage.clear()
    deleteCookie('DcpSessionId') // @todo DcpSessionId should be in sessionStorage
    yield put({type: actions.SESSION_IS_INACTIVE})
  }
}

export const authorizationSagas = [
  takeEvery(actions.LOGIN_REQUESTED, loginSaga),
  takeEvery(actions.LOGOUT_REQUESTED, logoutSaga),
  takeEvery(actions.CHECK_SESSION_STATUS, checkSessionStatusSaga)
]


// WEBPACK FOOTER //
// ./src/sagas/authorization.js